import { render } from "./HeatmapRegion.vue?vue&type=template&id=43b7406f"
import script from "./HeatmapRegion.vue?vue&type=script&lang=js"
export * from "./HeatmapRegion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__